var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 850,
    viewBox: "0 0 1440 850",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_577_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.979 106L629.952 414.8L951.608 363.046L659.601 502.14L810.422 778.954L581.979 556.12L353.536 778.954L504.357 502.14L212.351 363.046L534.006 414.8L581.979 106Z",
    fill: "url(#paint0_linear_577_231)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59,
    filter: "url(#filter1_f_577_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.312 0L365.739 97V291L198.312 388L30.884 291V97L198.312 0Z",
    fill: "#FCBC80",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59,
    filter: "url(#filter2_f_577_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.329 388L360.756 485V679L193.329 776L25.9011 679V485L193.329 388Z",
    fill: "#DC6146",
    fillOpacity: 0.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59,
    filter: "url(#filter3_f_577_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1086.23 0L1392.6 441H779.853L1086.23 0Z",
    fill: "#C08F87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_577_231",
    x: -47.6494,
    y: -154,
    width: 1259.26,
    height: 1192.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 130,
    result: "effect1_foregroundBlur_577_231"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_577_231",
    x: -269.116,
    y: -300,
    width: 934.855,
    height: 988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_577_231"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_577_231",
    x: -274.099,
    y: 88,
    width: 934.855,
    height: 988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_577_231"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_577_231",
    x: 479.853,
    y: -300,
    width: 1212.75,
    height: 1041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_577_231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_231",
    x1: 581.979,
    y1: 106,
    x2: 581.979,
    y2: 850,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#872341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#872341",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGradient);
export default __webpack_public_path__ + "static/media/bgGradient.fd078e160926b037216dcf07eb25db7b.svg";
export { ForwardRef as ReactComponent };